
const Navigable = {
  "name": "Navigable",
  "kind": "INTERFACE",
  "fieldBaseTypes": {
    "defaultCursor": "String"
  },
  "possibleTypes": ["Company", "CompanyLocation", "DraftOrder", "OnlineStoreArticle", "OnlineStorePage", "Product", "ProductVariant"]
};
export default Navigable;